import React from 'react';
import { Mail, Phone } from 'lucide-react';

export const LeadsPanel = ({ dashboardData }) => (
  <div data-testid="admin-leads-panel">
    <div className="bg-white rounded-xl border border-stone-200 overflow-hidden">
      <div className="px-6 py-4 border-b border-stone-200 bg-stone-50">
        <h3 className="font-medium text-stone-900">Recent Leads</h3>
        <p className="text-xs text-stone-500 mt-0.5">Enquiries, partner requests and calculator estimate leads from all venues</p>
      </div>
      <div className="divide-y divide-stone-100 max-h-96 overflow-y-auto">
        {dashboardData.recent_leads.length === 0 ? (
          <p className="px-6 py-8 text-center text-stone-500">No leads yet</p>
        ) : (
          dashboardData.recent_leads.map((lead, idx) => (
            <div key={idx} className="px-6 py-4">
              <div className="flex justify-between items-start">
                <div>
                  <p className="font-medium text-stone-900">{lead.type || 'Help Request'}</p>
                  <p className="text-sm text-stone-500 flex items-center gap-2 mt-1">
                    <Mail className="w-3 h-3" /> {lead.email}
                    {lead.phone && <><Phone className="w-3 h-3 ml-2" /> {lead.phone}</>}
                  </p>
                </div>
                <span className="text-xs text-stone-400">{new Date(lead.created_at).toLocaleDateString()}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>

    <div className="bg-white rounded-xl border border-stone-200 overflow-hidden mt-6">
      <div className="px-6 py-4 border-b border-stone-200 bg-stone-50 flex items-center justify-between">
        <h3 className="font-medium text-stone-900">Qualification Leads (Conversational)</h3>
        <div className="flex items-center gap-2">
          {dashboardData.qualificationStats && (
            <>
              <span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full">
                {dashboardData.qualificationStats.complete || 0} complete
              </span>
              <span className="text-xs bg-amber-100 text-amber-700 px-2 py-1 rounded-full">
                {dashboardData.qualificationStats.partial || 0} partial
              </span>
            </>
          )}
          <span className="text-xs bg-[#D4AF37]/20 text-[#D4AF37] px-2 py-1 rounded-full">
            {dashboardData.qualificationStats?.total || dashboardData.qualification?.length || 0} total
          </span>
        </div>
      </div>
      <div className="divide-y divide-stone-100 max-h-[500px] overflow-y-auto">
        {!dashboardData.qualification || !Array.isArray(dashboardData.qualification) || dashboardData.qualification.length === 0 ? (
          <p className="px-6 py-8 text-center text-stone-500">No qualification leads yet</p>
        ) : (
          dashboardData.qualification.map((lead, idx) => (
            <div key={idx} className="px-6 py-4">
              <div className="flex justify-between items-start mb-2">
                <div className="flex items-center gap-2">
                  {lead.is_partial ? (
                    <span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">Partial</span>
                  ) : lead.skipped ? (
                    <span className="text-xs bg-stone-100 text-stone-600 px-2 py-0.5 rounded-full">Skipped</span>
                  ) : (
                    <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full">Complete</span>
                  )}
                  {lead.timeline && (
                    <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">{lead.timeline.replace('-', ' ')}</span>
                  )}
                </div>
                <span className="text-xs text-stone-400">{new Date(lead.created_at).toLocaleDateString()}</span>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
                {lead.city && (
                  <div>
                    <span className="text-stone-400 text-xs">Location</span>
                    <p className="text-stone-700">{lead.city}{lead.locality && `, ${lead.locality}`}</p>
                  </div>
                )}
                {lead.wedding_date && (
                  <div>
                    <span className="text-stone-400 text-xs">Wedding Date</span>
                    <p className="text-stone-700">{lead.wedding_date}</p>
                  </div>
                )}
                {lead.room_count && (
                  <div>
                    <span className="text-stone-400 text-xs">Rooms</span>
                    <p className="text-stone-700">{lead.room_count}</p>
                  </div>
                )}
                {lead.phone && (
                  <div>
                    <span className="text-stone-400 text-xs">Phone</span>
                    <p className="text-stone-700 flex items-center gap-1">
                      <Phone className="w-3 h-3" />
                      {lead.phone}
                    </p>
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  </div>
);
